<template>
    <GenericModal size="modal-xxl" body-class="p-4" :show="showModal" @modal-action="modalAction">
        <template #title><h3>Log modifiche</h3></template>
        <template #default>
            <table class="table table-striped">
                <thead>
                    <tr><th scope="col" v-for="field in fields">{{ field }}</th></tr>
                </thead>
                <tbody>
                    <tr v-for="log in logs"><td v-for="field in fields" v-html="renderFieldValue(field, log[field])"></td></tr>
                </tbody>
            </table>
        </template>
    </GenericModal>
</template>
<style>
.diff-g {
    color: green;
}
.diff-r {
    color: red;
}
</style>
<script setup>
import { computed, ref } from 'vue';
import GenericModal from '@/components/generic-modal';
import { formatDateTime } from '@/utils'


const showModal = ref(false);
const logs = ref([]);


const show = (data) => {
    logs.value = data;
    showModal.value = true;
}

const hide = () => {
    showModal.value = false;
}

const modalAction = (action) => {
    if(action == 'close') {
        hide();
    }
}

defineExpose({
    show,
    hide
});

const fields = computed( () => {
    let keys = [];
    if(logs.value.length > 0) {
        keys = Object.keys(logs.value[0]);
    }
    return keys;
});

const renderFieldValue = (field, value) => {
    if(field == 'time') {
        return formatDateTime(value, "dd/MM/yyyy HH:mm");
    }
    return value;

}

</script>